export const featureFlags = {
  dataLoad: true,
  template: true,
  language: true,  
  formsToSign: true, 
}
